import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Icon, Link, Title } from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';

import routes from '../../../../../routes/routes';
import s from './MyInsiderIDModal.module.scss';

function MyInsiderIDModal({
  isOpen,
  onModalClose,
  version,
  tierName,
  loyaltyNumber,
  tierIcon,
  tierDescription,
  tierBenefits,
  tierBenefitsTitle,
  tierSubtitle,
}) {
  const theme = version === 'mobile' ? 'light' : 'dark'
  return (
    <Modal
      isOpen={isOpen}
      onModalClose={onModalClose}
      shouldCloseOnOverlayClick
      className={cn(s.modalTierProfile)}
    >
      <div className={s.modalTierProfileSubContainer}>
        <div className={s.titleWrapper} data-id="tier-icon-container">
          <div className={s.iconTierContainer}>
            <Icon icon={tierIcon} />
          </div>
          <Title tag="h1" className={s.titleInsider}>
            {tierName}
          </Title>
          {tierSubtitle && (
            <Title tag="h2" className={s.tierSubtitleECCHolder}>
              {tierSubtitle}
            </Title>
          )}
        </div>
        <div className={s.statusInsiderID}>
          <p className={s.tierMessage}>{tierDescription}</p>
          <Link
            as="a"
            theme={theme}
            size="body"
            href={routes.rewards.path}
          >
            Level Up Your Points
          </Link>
        </div>
        <div className={s.benefitsContainer}>
          <div className={s.benefitsHeader}>
            <Title tag="h5" className={s.benefits}>{tierBenefitsTitle}</Title>
            <Link
              as="a"
              theme={theme}
              size="body"
              className={s.seeMore}
              href="https://www.express.com/g/insider/program-benefits"
              aria-level={2}
            >
              Learn More
            </Link>
          </div>
          {tierBenefits && tierBenefits.length > 0 && (
          <ul className={s.benefitsList}>
            {tierBenefits.map((benefit) => (
              <li key={benefit.name}>
                <Icon icon={benefit.icon} />
                <span>{benefit.name}</span>
              </li>
            ))}
          </ul>
          )}
        </div>
        {loyaltyNumber && (
          <p className={s.modalTierExpressID}>
            EXPRESS ID:
            <strong>{loyaltyNumber}</strong>
          </p>
        )}
      </div>
    </Modal>
  );
}

MyInsiderIDModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  tierName: PropTypes.string,
  loyaltyNumber: PropTypes.string,
  tierIcon: PropTypes.string,
  tierDescription: PropTypes.PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  tierBenefits: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.shape({
        name: PropTypes.string,
        icon: PropTypes.string,
      }),
    ),
  ),
  tierBenefitsTitle: PropTypes.string,
  tierSubtitle: PropTypes.string,
  version: PropTypes.oneOf(['mobile', 'desktop']),
};

MyInsiderIDModal.defaultProps = {
  tierIcon: '',
  tierDescription: null,
  tierBenefits: [],
  version: 'desktop',
  tierBenefitsTitle: 'Your benefits',
  tierSubtitle: '',
  tierName: '',
  loyaltyNumber: '',
};

export default MyInsiderIDModal;
